module.exports = __webpack_public_path__ + "static/media/respiratory_rate.08c9271f.svg";